const HOIST = new Set([
  "grocery-daily-essentials",
  "baby-products",
  "grocery",
  "baby",
  "Grocery",
  "Baby",
]);

function phraseHit(hay, phrase) {
  const body = String(phrase || "")
    .toLowerCase()
    .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    .replace(/\\ /g, "[-\\s]+");
  return new RegExp(`(?<![a-z0-9])${body}s?(?![a-z0-9])`, "i").test(hay);
}

export function storeSlug(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export function subcategoryFor(title, category, rules = [], families = {}) {
  const stored = String(category || "");
  let family = "";
  for (const [name, ids] of Object.entries(families || {})) {
    if ((ids || []).some((id) => String(id).toLowerCase() === stored.toLowerCase())) {
      family = name;
      break;
    }
  }
  const names = Object.keys(families || {});
  const order = family ? [family, ...names.filter((name) => name !== family)] : names;
  const hay = String(title || "").toLowerCase();
  for (const name of order) {
    for (const rule of rules || []) {
      if (rule.family !== name) continue;
      if ((rule.phrases || []).some((phrase) => phraseHit(hay, phrase))) return rule.id;
    }
  }
  return "other";
}

export function sectionsFromTree(tree) {
  const sections = [];
  for (const dept of tree?.departments || []) {
    const categories = dept.categories || [];
    const hoisted = categories.filter((cat) => HOIST.has(cat.id));
    const rest = categories.filter((cat) => !HOIST.has(cat.id));
    for (const cat of hoisted) {
      sections.push({
        id: cat.id,
        label: cat.label,
        count: cat.count,
        kind: "category",
        children: (cat.subcategories || []).map((sub) => ({
          id: sub.id,
          label: sub.label,
          count: sub.count,
        })),
      });
    }
    if (!rest.length) continue;
    sections.push({
      id: dept.id,
      label: dept.label,
      count: rest.reduce((sum, cat) => sum + (cat.count || 0), 0),
      kind: "department",
      children: rest.map((cat) => ({
        id: cat.id,
        label: cat.label,
        count: cat.count,
        children: (cat.subcategories || []).map((sub) => ({
          id: sub.id,
          label: sub.label,
          count: sub.count,
        })),
      })),
    });
  }
  return sections;
}

export function ensureShopCategories(sections) {
  return (sections || []).filter((row) => row.count == null || row.count > 0);
}

export function shopPath(entry = {}) {
  const next = new URLSearchParams();
  if (entry.dept) next.set("dept", entry.dept);
  if (entry.category) next.set("category", entry.category);
  if (entry.sub) next.set("sub", entry.sub);
  if (entry.brand) next.set("brand", entry.brand);
  const text = next.toString();
  return text ? `/shop?${text}` : "/shop";
}

export function navEntries(tree) {
  const entries = [];
  for (const section of sectionsFromTree(tree || {})) {
    if (!section.count) continue;
    if (section.kind === "department") {
      entries.push({ key: section.id, label: section.label, dept: section.id });
      for (const child of section.children || []) {
        if (!child.count) continue;
        entries.push({
          key: `${section.id}:${child.id}`,
          label: `${section.label} · ${child.label}`,
          dept: section.id,
          category: child.id,
        });
      }
      continue;
    }
    entries.push({ key: section.id, label: section.label, category: section.id });
  }
  return entries;
}
